import React from "react";
import { Box, Typography } from "@mui/material";
import useRTL from 'src/hooks/useRTL';
import { useCompanyData } from '../../shared/contexts/DataContext';
import { textVariant, textClasses } from '../../shared/config';

function SectionTitle({ children, noWrap, ...props }) {
  const { data } = useCompanyData();
  const { generalTitleFontSize, generalTitleColor } = data || {};
  const titleFontColor = props.color ? props.color : generalTitleColor ? generalTitleColor : '#15476D';

  const [, , fontFamily] = useRTL('',"Playfair Display, serif");

  const variant = props?.pFontSize && textVariant?.[props?.pFontSize] ? textVariant?.[props?.pFontSize] :
  generalTitleFontSize && textVariant?.[generalTitleFontSize] ? textVariant?.[generalTitleFontSize] : textVariant?.['62'];
  
  const fontSizeCls = props?.pFontSize && textClasses?.[props?.pFontSize] ? textClasses?.[props?.pFontSize] :
  generalTitleFontSize && textClasses?.[generalTitleFontSize] ? textClasses?.[generalTitleFontSize] : textClasses?.['62'];

  return (
    <Box
      fontWeight={700}
      color={titleFontColor}
      style={{fontFamily:fontFamily}}
      {...props}
    >
      <Typography
      noWrap={noWrap}
      variant={variant}
      className={`${fontSizeCls} ${props?.customCls || ''}`}
      style={{textTransform:'capitalize',fontWeight:'inherit'}}>
        {children}
      </Typography>
    </Box>
  );
};

function SectionSubtitle({ children, ...props }) {
  const { data } = useCompanyData();
  const { generalSubTitleFontSize, generalSubTitleColor } = data || {};
  const subTitleFontColor = props.color ? props.color : generalSubTitleColor ? generalSubTitleColor : '#17C799';

  const [, , fontFamily] = useRTL('',"'Roboto', sans-serif");

  const variant = props?.pFontSize && textVariant?.[props?.pFontSize] ? textVariant?.[props?.pFontSize] :
  generalSubTitleFontSize && textVariant?.[generalSubTitleFontSize] ? textVariant?.[generalSubTitleFontSize] : textVariant?.['18'];
  
  const fontSizeCls = props?.pFontSize && textClasses?.[props?.pFontSize] ? textClasses?.[props?.pFontSize] :
  generalSubTitleFontSize && textClasses?.[generalSubTitleFontSize] ? textClasses?.[generalSubTitleFontSize] : textClasses?.['18'];

  return (
    <Box
      color={subTitleFontColor}
      {...props}
      style={{fontFamily:fontFamily}}
      >
      <Typography
        variant={variant}
        className={fontSizeCls}
      >
        {children}
      </Typography>
    </Box>
  );
};


function SectionParagraph({ children, ...props }) {
  const { data } = useCompanyData();
  const { generalParagraphFontSize, generalParagraphColor } = data || {};
  const descFontColor = props.color ? props.color : generalParagraphColor ? generalParagraphColor : '#000';

  const [, , fontFamily] = useRTL('',"'Roboto', sans-serif");

  const variant = props?.pFontSize && textVariant?.[props?.pFontSize] ? textVariant?.[props?.pFontSize] :
  generalParagraphFontSize && textVariant?.[generalParagraphFontSize] ? textVariant?.[generalParagraphFontSize] : textVariant?.['16'];
  const fontSizeCls = props?.pFontSize && textClasses?.[props?.pFontSize] ? textClasses?.[props?.pFontSize] :
  generalParagraphFontSize && textClasses?.[generalParagraphFontSize] ? textClasses?.[generalParagraphFontSize] : textClasses?.['16'];

  return (
    <Box
      color={descFontColor}
      {...props}
      style={{fontFamily:fontFamily}}
      >
      <Typography 
        variant={variant}
        className={fontSizeCls}
        dangerouslySetInnerHTML={props.description}
      />
      </Box>
  );
};

export {
  SectionTitle,
  SectionSubtitle,
  SectionParagraph
};

// export default SectionTitle;
